import React, { JSX } from 'react';
import Texts from '../../../assets/utils/texts';

const ProviderInsurance = (): JSX.Element => {
  return (
    <div id="insurance" className="provider-insurance">
      <div className="profile-insurance">
        <h2>{Texts.AcceptedInsurance}</h2>
        <p className='accepted-insurance'>
          Visit our insurance page for a list of{' '}
          <a
            className="ins-link"
            href="https://x.osfhealthcare.org/patients-visitors/billing-insurance/insurance/insurance-plans-accepted"
          >
            accepted insurances
          </a>
          . For specific plan information, check with your insurance provider.
        </p>
      </div>
    </div>
  );
};

export default ProviderInsurance;
